import {
  AppSearch,
  AppSearchResponse,
  StorageGraphData,
  StorageData,
  StorageVehicle,
  StorageVehicleFilters,
} from '@/types';
import {
  Core,
  STORAGE,
  STORAGE_CHECKOUT_VEHICLES,
  STORAGE_GRAPH,
  STORAGE_VEHICLES,
  STORAGE_VEHICLES_FILTERS,
} from '../Core';

class Storage extends Core {
  getStorage = async () => this.get<StorageData>(STORAGE());

  getGraph = async () => this.get<StorageGraphData>(STORAGE_GRAPH());

  getStorageVehiclesFilters = async () =>
    this.get<StorageVehicleFilters>(STORAGE_VEHICLES_FILTERS());

  postStorageVehicles = async (body: AppSearch<StorageVehicle>) =>
    this.post<AppSearchResponse<StorageVehicle>>(STORAGE_VEHICLES(), body);

  checkoutVehicle = async (vin: string) =>
    this.post<number>(STORAGE_CHECKOUT_VEHICLES(vin));
}

export const storage = new Storage();
